<!-- eslint-disable max-len -->
<template>
  <div>
    <HeaderLanding></HeaderLanding>
    <b-container fluid class="mt-5 mb-5" style="min-height: 65vh;" >
      <b-row align-h="center" style="margin-bottom: 40px">
        <b-col cols="12" md="4" >
          <font-awesome-icon :icon="['fas', 'check-circle']" class="text-success my-auto success-icon"></font-awesome-icon>
          <h3 class="font-weight-bolder mt-3">Email Verified!</h3>
          <p class="" style="margin-bottom: 55px">You have successfully verified your email. Please log in to your account to continue.</p>
          <a class="btn btn-primary btn-block" href="/#/login" >Log In</a>
        </b-col>
      </b-row>
    </b-container>
    <FooterLanding></FooterLanding>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import HeaderLanding from '../components/HeaderLanding';
import FooterLanding from '../components/FooterLanding';

export default {
  name: 'VerificationEmail',
  data: () => ({

  }),
  computed: {
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode']),
  },
  methods: {
    ...mapActions('EmailModule', ['requestVerify']),
  },
  async mounted() {
    if(this.$route.query._t!==undefined){
      const res = await this.requestVerify(this.$route.query._t);
      console.log(res);
    }else{
      this.$router.push({ name: 'Signin' });
      return;
    }

  },
  components: {
    HeaderLanding,FooterLanding
  }
};
</script>
<style scoped>
.success-icon{
  font-size: 134px
}
</style>



// WEBPACK FOOTER //
// src/views/VerificationEmail.vue